import { render } from "./Penelitian.vue?vue&type=template&id=9726fd1a"
import script from "./Penelitian.vue?vue&type=script&lang=js"
export * from "./Penelitian.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__